import React from 'react'
import { useTranslation } from 'react-i18next';
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import EmptyData from '../../../components/ui/EmptyData';
import Layout from '../../../components/layouts/Layout';
import { useRolesByAdmin } from '../../../hooks/admin/roles.admin';
import RolesListTable from '../../../components/admin/roles/RolesListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewRolesPage() {
  const {t} = useTranslation();
    
  const {data:roles,isLoading,isError} = useRolesByAdmin(true);
  return (
    <Layout title={t('admin_sidebar.roles')} headline=''>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateRole]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_role"
              buttonLinkPath={`/admin/add-role`}
              />
            </PermissionGate>
         </div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
         {
        roles && (
          roles.length === 0 ?<EmptyData/> : <RolesListTable roles={roles}/>
        )
        }
    </Layout>
  )
}

export default AdminViewRolesPage